import React from 'react'
import { useNavigate } from 'react-router-dom'
const Shoppingcartmodal = ( {onClose}) => {
    const navigate = useNavigate()

    
      const handleNavigation = (path) => {
        onClose();
        setTimeout(() => {
          window.scrollTo(0, 0);
          navigate(path); 
        }, 1000); 
      };
      
  return (
    <div>
        <h2 className='my-[20px] text-[#00296B] font-bold'> SIGN IN AS A</h2>
     <div className='flex gap-[20px] mb-[20px] cursor-pointer'>
     <p onClick={() => handleNavigation("/store-login-teacher")}>Teacher</p>
        <p onClick={() => handleNavigation("/store-login-student")}>Student</p>
        <p onClick={() => handleNavigation("/store-login-guest")}>Guest</p>
     </div>
    </div>
  )
}

export default Shoppingcartmodal